const mediaItems = [
  {
    title: '暑期档爆款推荐',
    desc: '这个夏天不容错过的十部高分电影，部部精彩绝伦',
    img: 'https://readdy.ai/api/search-image?query=Summer%20blockbuster%20movie%20collage%20with%20warm%20golden%20cinematic%20lighting%2C%20film%20poster%20style%20aesthetic%2C%20deep%20crimson%20and%20gold%20accents%2C%20clean%20simple%20composition%2C%20dramatic%20theater%20atmosphere&width=800&height=500&seq=media-01&orientation=landscape',
    tag: '电影合集',
    icon: 'ri-film-line',
  },
  {
    title: '国产悬疑剧高光时刻',
    desc: '近两年口碑爆棚的国产悬疑剧大盘点',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20drama%20visual%20with%20dark%20warm%20atmospheric%20lighting%2C%20film%20noir%20inspired%20composition%2C%20deep%20red%20and%20shadow%20tones%2C%20cinematic%20suspense%20aesthetic%2C%20clean%20simple%20background&width=800&height=500&seq=media-02&orientation=landscape',
    tag: '悬疑剧场',
    icon: 'ri-search-eye-line',
  },
  {
    title: '韩剧精选 · 年度必追',
    desc: '2024 年度最值得一看的韩剧推荐清单',
    img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20cinematic%20scene%20with%20warm%20soft%20lighting%2C%20elegant%20visual%20storytelling%20style%2C%20gentle%20golden%20and%20rose%20tones%2C%20clean%20composition%2C%20drama%20series%20aesthetic&width=800&height=500&seq=media-03&orientation=landscape',
    tag: '韩剧推荐',
    icon: 'ri-hearts-line',
  },
  {
    title: '科幻迷的视听盛宴',
    desc: '从硬核科幻到奇幻冒险，满足你的想象力',
    img: 'https://readdy.ai/api/search-image?query=Science%20fiction%20cinematic%20visual%20with%20futuristic%20warm%20neon%20accents%2C%20space%20and%20technology%20elements%2C%20deep%20crimson%20and%20amber%20lighting%2C%20clean%20sci-fi%20aesthetic%2C%20dramatic%20composition&width=800&height=500&seq=media-04&orientation=landscape',
    tag: '科幻世界',
    icon: 'ri-planet-line',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">精选推荐</h2>
        <p className="text-sm text-foreground-600 text-center mb-10 md:mb-12">编辑精心挑选，为你推荐最值得看的影视内容</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <a
              key={item.title}
              href="#carousel"
              className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-300 transition-colors cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs bg-background-50/90 text-foreground-800 px-2.5 py-1 rounded-full whitespace-nowrap flex items-center gap-1">
                    <i className={`${item.icon} text-primary-500 text-xs`}></i>
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base group-hover:text-primary-600 transition-colors mb-1.5">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}